import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../../assets/styles/_ecModal.modules.scss";

const ECModal = ({ isOpen, onClose, children, ecLinks }) => {
  const pathname = useLocation().pathname;

  useEffect(() => {
    const handleClick = (e) => {
      if (e.target.classList.contains("modalOverlay")) {
        onClose();
      }
    };
    window.addEventListener("click", handleClick);
    return () => {
      window.removeEventListener("click", handleClick);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modalOverlay">
      <div className="modalContainer">
        <button className="modalClose" onClick={onClose}>
          &times;
        </button>
        <div className="modalContent">
          <a
            className={`modalBtns ${
              pathname === "/product-detail-deep" ? "pink" : ""
            } ${pathname === "/product-detail-sleek" ? "blue" : ""}`}
            href={ecLinks.amazon}
            target="_blank"
            rel="noreferrer"
          >
            Amazonで購入する
          </a>
          <a
            className={`modalBtns ${
              pathname === "/product-detail-deep" ? "pink" : ""
            } ${pathname === "/product-detail-sleek" ? "blue" : ""}`}
            href={ecLinks.rakuten}
            target="_blank"
            rel="noreferrer"
          >
            楽天で購入する
          </a>
          <a
            className={`modalBtns ${
              pathname === "/product-detail-deep" ? "pink" : ""
            } ${pathname === "/product-detail-sleek" ? "blue" : ""}`}
            href={ecLinks.q10}
            target="_blank"
            rel="noreferrer"
          >
            Q10で購入する
          </a>
          <a
            className={`modalBtns ${
              pathname === "/product-detail-deep" ? "pink" : ""
            } ${pathname === "/product-detail-sleek" ? "blue" : ""}`}
            href={ecLinks.yahoo}
            target="_blank"
            rel="noreferrer"
          >
            Yahoo!で購入する
          </a>
        </div>
      </div>
    </div>
  );
};

export default ECModal;
